module.exports = __webpack_public_path__ + "img/5.01.thmb.xs.a8578b86.jpg";